import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import { CustomFieldAttribute, CustomFieldEntity } from 'apis/customFields';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

type EditActionProps = {
  attribute: CustomFieldAttribute;
  entityId: CustomFieldEntity;
};

/** Represents the edit action of a custom attributes table row item. */
export const EditAction = ({
  attribute,
  entityId,
}: EditActionProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const handleClick = useCallback(() => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'settings:customAttribute',
          arg: { entityId, mode: 'edit', attribute },
        },
      }),
    );
  }, [dispatch, attribute, entityId]);

  return (
    <Tooltip content="Edit" dark>
      <IconButton icon="pen" variant="tertiary" onClick={handleClick} />
    </Tooltip>
  );
};
